import { initSentry } from "@/lib/sentry";
import { initWebVitals } from "@/lib/web-vitals";
import { initAnalytics } from "@/lib/analytics";

// Initialize Sentry before rendering (production only)
initSentry();
// Initialize Web Vitals capture (env-gated; samples per VITE_WEB_VITALS_SAMPLE_RATE)
initWebVitals();
// Initialize PostHog analytics (env-gated; no-ops if VITE_POSTHOG_API_KEY unset)
initAnalytics();

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
